// extracted by mini-css-extract-plugin
module.exports = {"image":"c4","image-placeholder":"c5","imagePlaceholder":"c5"};